export default "__VITE_ASSET__BCNa01Bb__"